import { apiClient } from './client';

/**
 * NPI Registry lookup. Backed by the FastAPI proxy at
 * `GET /api/v1/npi/{number}`, which in turn calls the public CMS
 * NPI Registry. The portal proxies through the API so the lookup
 * stays auth-gated and the response shape is normalised — see
 * api/app/services/npi.py for the parser.
 */
export interface NpiLookupResult {
  npi: string;
  first_name: string | null;
  last_name: string | null;
  credential: string | null;
  full_name: string | null;
  phone: string | null;
  fax: string | null;
  address_line1: string | null;
  address_line2: string | null;
  city: string | null;
  state_region: string | null;
  postal_code: string | null;
  country: string | null;
  taxonomy_primary: string | null;
}

export async function lookupNpi(number: string): Promise<NpiLookupResult> {
  const { data } = await apiClient.get<NpiLookupResult>(
    `/api/v1/npi/${encodeURIComponent(number)}`,
  );
  return data;
}
